/**
 * Movataa Scroll Animations v3
 * IntersectionObserver-based reveals — no layout shift, no jQuery
 * Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Selectors that get a fade-up reveal ── */
  var REVEAL_SELECTORS = [
    /* PDP custom sections */
    '.movataa-clinical',
    '.movataa-howto',
    '.movataa-free-from',
    '.movataa-product-trust',
    '.movataa-psr',
    '.movataa-benefits',
    '.movataa-tl',
    '.movataa-cmp',
    /* HP custom sections */
    '.hp-stats',
    '.hp-concern',
    '.hp-why',
    '.hp-cols',
    '.hp-routine',
    '.hp-quiz-cta',
    '.hp-collections',
    /* Motto native sections */
    '.section-blockquote',
    '.section-testimonials',
    '.section-image-with-text',
    '.section-before-after',
    '.section-card-list',
    '.section-brand-image',
    '.section-image-collage',
    '.section-rich-text',
    '.section-multicolumn',
    '.section-media',
    '.section-newsletter',
    '[class*="product-recommendations"]',
    '[class*="product-complementary"]',
  ];

  /* ── Selectors whose direct children get staggered ── */
  var STAGGER_SELECTORS = [
    '.hp-concern__grid',
    '.hp-why__grid',
    '.hp-cols__grid',
    '.movataa-benefits__grid',
    '.movataa-actives__grid',
    '.movataa-clinical__grid',
    '.movataa-psr__grid',
    '.movataa-tl__row',
    '.multicolumn-list',
    '.media-section__grid',
    '.brand-image__grid',
  ];

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Reveal observer ── */
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });

    REVEAL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('movataa-reveal')) {
          el.classList.add('movataa-reveal');
        }
        revealObserver.observe(el);
      });
    });

    /* Also observe anything already tagged */
    document.querySelectorAll('.movataa-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });

    /* ── Stagger observer ── */
    var staggerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          staggerObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

    STAGGER_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('movataa-stagger')) {
          el.classList.add('movataa-stagger');
        }
        staggerObserver.observe(el);
      });
    });

    /* ── Lazy image fade-in ── */
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('loaded');
        });
      }
    });

    /* ── Sticky mobile ATC bar ── */
    initStickyATC();

    /* ── Smooth counter animation for hp-stats ── */
    initCounters();

    /* ── Concern card subtle tilt ── */
    initCardTilt();

  });

  /* ── Sticky ATC ── */
  function initStickyATC() {
    var bar = document.getElementById('movataa-sticky-atc');
    if (!bar) return;
    var mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          if (mainBtn.getBoundingClientRect().top < 0) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        }
      });
    }, { threshold: 0, rootMargin: '0px' }).observe(mainBtn);
  }

  /* ── Counters: hp-stats already has its own observer ── */
  function initCounters() {
    /* hp-stats snippet handles its own counters via its own IntersectionObserver */
  }

  /* ── Subtle card interaction on concern/why grid ── */
  function initCardTilt() {
    var cards = document.querySelectorAll('.hp-concern__card, .hp-why__card');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-6px) rotateX(' + (-y * 4) + 'deg) rotateY(' + (x * 4) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

}());
